module.exports = __webpack_public_path__ + "img/Account.cd541161.png";